import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SplashScreen = _resolveComponent("SplashScreen")!
  const _component_LoginForm = _resolveComponent("LoginForm")!
  const _component_LoginLayout = _resolveComponent("LoginLayout")!
  const _component_LoginOtp = _resolveComponent("LoginOtp")!
  const _component_CookieConsent = _resolveComponent("CookieConsent")!

  return (_ctx.resetCacheLoading)
    ? (_openBlock(), _createBlock(_component_SplashScreen, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (!_ctx.otpRequired)
          ? (_openBlock(), _createBlock(_component_LoginLayout, {
              key: 0,
              class: "login-layout__login",
              title: _ctx.t('Login to {merchantBrand}', { merchantBrand: _ctx.merchantBrand }),
              subtitle: 
        _ctx.t('Sign in into {siteSetting} {merchantBrand} account', {
          siteSetting: _ctx.siteSetting,
          merchantBrand: _ctx.merchantBrand,
        })
      ,
              showLogo: ""
            }, {
              body: _withCtx(() => [
                _createVNode(_component_LoginForm, { onOnOtpRequired: _ctx.onOtpRequired }, null, 8, ["onOnOtpRequired"])
              ]),
              _: 1
            }, 8, ["title", "subtitle"]))
          : (_openBlock(), _createBlock(_component_LoginOtp, {
              key: 1,
              onGoBack: _ctx.goBack
            }, null, 8, ["onGoBack"])),
        _createVNode(_component_CookieConsent)
      ], 64))
}